<template>
    <div class="main-content" id="panel">
        <div class="header bg-primary pb-6">
            <div class="container-fluid">
            <div class="header-body">
                <div class="row align-items-center py-4">
                    <div class="col-lg-6 col-6">
                    <h2>Representative</h2>
                    </div>
                    <div class="col-lg-6 col-6 text-right bid">
                    <button type="button" @click="toggleAddRepresentativeOpen()" class="btn btn-success rounded ml-1"> <i class="fas fa-suitcase"></i> ADD</button>

                    <!-- <form @submit.prevent="" class="form-inline d-flex justify-content-center md-form form-sm mt-0">
                        <i @click="searchRepresentative()"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
                        <input v-on:keyup.enter="searchRepresentative" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm ml-3 w-75" type="text" placeholder="Search" aria-label="Search">
                        <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
                        </form>               -->
                    </div>
                </div>
                
            </div>
            </div>
        </div>
        <div class="container-fluid mt--6" >
            <div class="row">
                 <div class="col-xl-12">
                    <div class="card vh-75" id="scroll">
                        <div class="table-responsive">
                        <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>
                        <table class="table align-items-center table-flush table-hover bidtbl">
                            <thead class="thead-light psticky">
                            <tr>
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                    v-bind:class="[sortOrder == 'ASC' && sortColumn == 'firstName'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'firstName'  ? 'sort-desc' : '']"  
                                    @click="sort('firstName')">Name</th>
                                <th 
                                    scope="col" 
                                    class="sort text-center"
                                    >Action</th>    
                                    
                            </tr>
                            </thead>
                            <tbody class="list no-cursor">
                            <tr v-if="representativeData.length == 0 && !loading">
                                <td><p class="nodata">No data available</p>
                                </td>
                            </tr>
                            <tr v-for="data in representativeData" :key="data.id">
                                <td class="text-center">{{data.firstName}} {{data.lastName}}</td>
                                <td class="text-center">

                                  <a @click="openRepresentativeEditPoup(data)" class="btn ibtn grn"><i class="fas fa-pencil-alt"></i></a>
                                  <button @click="deleteRep(data)" class="btn ibtn btn-outline-danger" title="Delete"><i class="far fa-trash-alt"></i></button>
                                  
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        </div>
                    </div>
                    </div>
            </div>
        </div>
        <AddRepresentative
          v-bind:selectedRepresentativeData="selectedRepresentativeData"
          v-if="representativeModalOpen"
          @close="toggleAddRepresentativeOpen()"
        ></AddRepresentative>
    </div>      
</template>
<script>
import config from "@/config";
import authService from "@/authService";
import AddRepresentative from "./AddRepresentativeModal"
export default {
  name: "imsRepresentativeComponent",
  components : {
    AddRepresentative
  },
  data() {
    return {
        accessToken:null,
        loading : false,
        currentPage: 1,
        perPage: 50,
        searchValue : "",
        totalRows : 0,
        sortColumn: "account",
        sortOrder: "ASC",
        representativeData : [],
        selectedRepresentativeData : null,
        representativeModalOpen : false
    };
  },
  methods: {
    deleteRep(rep){
      var message = "Are you sure you want to delete?";
      this.$confirm(message,"","question",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
          this.loading = true;
          const auth = {
              headers: { 'org-token' : authService.getOrgToken()  }
          };
          let data = {
                  "id":rep.id,
                  "status":"INACTIVE"
              }
          this.$http
          .put(config.baseUrlAutoBidder + "/money-line/representative",data,auth)
          .then(() => {
            this.loading = false;  
            this.$alert("Rep deleted successfully","","success");            
            this.getRepresentativeList();
           
          })
          .catch(() => {
              this.loading = false;              
          });
      });
    },
    toggleAddRepresentativeOpen(){
        this.selectedRepresentativeData = null;
        this.representativeModalOpen = !this.representativeModalOpen;
        if(!this.representativeModalOpen){
            this.getRepresentativeList(); 
        }
    },
    openRepresentativeEditPoup(data){
        this.selectedRepresentativeData = data;
        this.representativeModalOpen = true;
    },
    searchRepresentative(){
      this.getRepresentativeList(); 
    },
    clearSearch(){
      this.searchValue = "";
      this.getRepresentativeList(); 
    },
    sort(column){
      this.sortColumn = column;
      this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
      this.getRepresentativeList();
    },
    getRepresentativeList() {
      this.loading = true;
      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      let url = "/money-line/representative-list";
      this.$http
        .get(
          config.baseUrlAutoBidder +
            url,
            auth
        )
        .then(result => {
           this.representativeData = result.data
           this.loading = false;
        })
    }
  },
  mounted() {
    this.getRepresentativeList()
  }
};
</script>